function accordionAction (titleElement) {
  // panel is the description. which title clicked, selected its panel and show/collapse based on the panel current state.

  // Getting the down arrow of the selected accordion title.
  let titleSymbol = titleElement.getElementsByTagName('span')
  if (titleSymbol.length > 0) {
    titleSymbol = titleSymbol[0]
    // If element contains "Open" class need to remove. otherwise need to add
    if (titleSymbol.classList.contains('collapsible-trigger__icon_open')) {
      titleSymbol.classList.remove('collapsible-trigger__icon_open')
    } else {
      titleSymbol.classList.add('collapsible-trigger__icon_open')
    }
  }

  const panel = titleElement.nextElementSibling
  // For accordion animation for open and collapse.
  let expanded = titleElement.getAttribute('aria-expanded') === 'true' || false
  titleElement.setAttribute('aria-expanded', !expanded)

  if (panel.style.maxHeight) {
    panel.style.maxHeight = null
  } else {
    panel.style.maxHeight = `${panel.scrollHeight}px`
  }
}

window.addEventListener('load', function () {
  const bundleBannerLink = document.querySelector('.bundle-banner a')
  if (bundleBannerLink) {
    bundleBannerLink.addEventListener('click', function (event) {
      const bundleChilds = document.querySelector('#bundle_items')
      if (FH.theme_settings.header_sticky_enable) { // only handle when sticky is enable
        event.preventDefault()
        const headerHeight = document.querySelector('.sticky-wrapper').offsetHeight // get the height of the sticky header
        const targetPosition = bundleChilds.getBoundingClientRect().top + window.scrollY // get the top position of the bundle products
        const offsetPosition = targetPosition - headerHeight // subtract the height of the sticky header from the bundle products
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' }) // scroll to the bundle products with the offset position
      }
      if (bundleChilds.getAttribute('aria-expanded') === 'false') {
        bundleChilds.click() // open according on banner link click
      }
    })
  }
})
